<template>
  <div>
    <table v-if="hasDiffs" class="mergeTable" width="100%">
        <thead>
        <tr>
          <th align="center" width="33%" style="padding-right: 5px;"><a @click="res = JSON.parse(JSON.stringify(o))">Старое</a>
          </th>
          <th align="center" width="34%"
              style="border-left: solid 1px lightgrey; border-right: solid 1px lightgrey; padding: 0 5px;"> ← diff →
          </th>
          <th align="center" width="33%" style="padding-left: 5px;"><a
              @click="res = JSON.parse(JSON.stringify(n))">Новое</a></th>
        </tr>
        </thead>
        <tbody v-for="(eee,index) in maxCount">
        <tr>
          <td v-if="oToText[index]" :class="{'selected': res[index] === oToText[index]}" valign="top"
              style="padding-right: 5px;">
            <a @click="setRes(index, 'old')">{{ oToText[index] }}</a>
          </td>
          <td v-else valign="top"
              :class="{'selected': res[index] === oToText[index]}"
              style="padding-right: 5px;"><a @click="res.splice(index,1)">X</a></td>
          <td valign="top" style="border-left: solid 1px lightgrey; border-right: solid 1px lightgrey; padding: 0 5px;">
            <span class="diff" v-html="getDiff(index)"/>
          </td>
          <td v-if="nToText[index]" :class="{'selected': res[index] === nToText[index]}" valign="top"
              style="padding-left: 5px;">
            <a @click="setRes(index, 'new')">{{ nToText[index] }}</a>
          </td>
          <td v-else :class="{'selected': res[index] === nToText[index] }" valign="top" style="padding-right: 5px;"><a @click="res.splice(index,1)">X</a></td>
        </tr>
        </tbody>
    </table>
    <table class="mergeTable" width="100%">
      <thead>
      <tr>
        <th align="center" colspan="100%">Актуальное</th>
      </tr>
      </thead>
      <tr v-for="(row, assocRowIndex) in res" style="height: 31px" track-by="$index">
        <td colspan="97%" class="selected">
          <input v-model="res[assocRowIndex]" ref="association"
                 @paste="onPasteAssociations(assocRowIndex, $event)"
                 class="associationName"
                 v-beautify.literal="'capitalize itemclean rtrimpunctuation typograf onlyonblur'"
                 placeholder="Название ассоциации"/>
        </td>
        <td colspan="3%" class="selected" align="right">
          <button class="small redHover square" @click.prevent="removeAssociation(assocRowIndex)" tabindex="-1"><i
              class="far fa-trash-can"></i></button>
        </td>
      </tr>
      <tfoot>
      <tr style="height: 38px;">
        <td colspan="100%" style="text-align: center;">
          <button class="small addAssociation" @click.prevent="addAssociation(true)" tabindex="-1">
              Добавить ассоциацию
          </button>
        </td>
      </tr>
      </tfoot>
    </table>
  </div>
</template>
<script>
import Base from "../Base.vue";
import DiffMatchPatch from 'diff-match-patch';
import _ from "lodash";

export default {
  mixins: [Base],
  props: {
    o: {
      type: [Array],
      default: ''
    },
    n: {
      type: [Array],
      default: ''
    },
    f: {
      type: [Array],
      default: ''
    },
  },
  methods: {
    textToAssociations(line, index) {
      line = line.split('\n').join(' ').trim();
      if (!_.isEmpty(line)) {
        let data = this.cutLastComma(_.upperFirst(line).trim());
        if (index === null) {
        if (this.res[this.res.length - 1] === '') {
          this.res[this.res.length - 1] = data;
        } else {
          this.res.push(data);
        }
        } else {
          this.res.splice(index, 1, data);
        }
      }
    },
    onPasteAssociations(index, e) {
      let input = this.$refs.association[index];
      let text = e.clipboardData.getData('text/plain');

      if (input.value) {
        text = input.value.substring(0, input.selectionStart) + text + input.value.substring(input.selectionEnd);
      }

      this.textToAssociations(text, index);
      e.preventDefault();

      this.inputAssociation();
    },
    setRes(index, type) {
      if (type === 'old') {
        this.res.splice(index, 1, JSON.parse(JSON.stringify(this.o[index])));
      }
      if (type === 'new') {
        this.res.splice(index, 1, JSON.parse(JSON.stringify(this.n[index])));
      }
    },
    addAssociation() {
      this.res.push('');
    },
    removeAssociation(index) {
      this.res.splice(index, 1);
    },

    getDiff(index) {
      let dmp = new DiffMatchPatch();
      let d = dmp.diff_main(this.oToText[index] ?? '', this.nToText[index] ?? '');
      dmp.diff_cleanupEfficiency(d);
      return dmp.diff_prettyHtml(d);
    },
    inputAssociation() {
      if (this.res.length === 0 || (this.res[this.res.length - 1] !== '')) {
        this.addAssociation();
      }
    },
    cutLastComma(text) {
      if (text[text.length - 1] === ',') {
        text = text.slice(0, text.length - 1);
      }

      return text;
    },
  },
  computed: {
    hasDiffs() {
      return !_.isEqual(this.o, this.n)
    },
    currentYear() {
      return new Date().getFullYear() ?? 2400;
    },
    oToText() {
      return this.o
    },
    nToText() {
      return this.n
    },
    maxCount() {
      return Math.max(this.oToText.length, this.nToText.length)
    },
  }
}
</script>
